import { CASH } from '@makemydeal/dr-platform-types';
import type { ValidationConfig } from '../validationEngine/types';
import { validateLendersListPhone } from '../utils/lenderValidationUtils';
const INLINE_AND_CONTRACT_FLOW = 'default+contract';

export const LENDER_ADDRESS_MAX_LENGTH = {
    line1: 60,
    line2: 60,
    city: 30,
    state: 2,
    postalCode: 9
} as const;

export const LENDER_ADDRESS_FIELD_PATHS = ['line1', 'line2', 'city', 'postalCode', 'phone'] as const;

export const lenderValidationConfig: ValidationConfig = {
    name: {
        rules: [
            {
                type: 'REQUIRED',
                flow: 'contract',
                messages: 'Lender selection is required for Finance and Lease deals.',
                conditions: { excludeOfferTypes: [CASH] }
            }
        ]
    },
    line1: {
        rules: [
            {
                type: 'MAX_LENGTH',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: { max: LENDER_ADDRESS_MAX_LENGTH.line1 },
                messages: {
                    inline: 'Street Address can’t be longer than 60 characters.',
                    gcalert: 'Street Address cannot be longer than 60 characters.'
                }
            },
            {
                type: 'REGEX',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: { regex: /^[A-Za-z0-9 #\\\-/.',]*$/ },
                messages: "Use only letters, numbers, and # / \\ - . ' ,"
            }
        ]
    },
    line2: {
        rules: [
            {
                type: 'MAX_LENGTH',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: { max: LENDER_ADDRESS_MAX_LENGTH.line2 },
                messages: {
                    inline: 'Street Address 2 can’t be longer than 60 characters.',
                    gcalert: 'Street Address 2 cannot be longer than 60 characters.'
                }
            },
            {
                type: 'REGEX',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: { regex: /^[A-Za-z0-9 #\\\-/.',:]*$/ },
                messages: "Use only letters, numbers, and # / \\ - . ' , :"
            }
        ]
    },
    city: {
        rules: [
            {
                type: 'MAX_LENGTH',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: { max: LENDER_ADDRESS_MAX_LENGTH.city },
                messages: {
                    inline: 'City can’t be longer than 30 characters.',
                    gcalert: 'City cannot be longer than 30 characters.'
                }
            },
            {
                type: 'REGEX',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: { regex: /^[A-Za-z0-9 #\-/.']*$/ },
                messages: "Use only letters, numbers, and # / - . '"
            }
        ]
    },
    // Lender titling zip is stored dash-free (e.g. "110421123"). Validate on both flows that it is no
    // longer than 9 characters; no minimum length and no format check.
    postalCode: {
        rules: [
            {
                type: 'MAX_LENGTH',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: { max: LENDER_ADDRESS_MAX_LENGTH.postalCode },
                messages: {
                    inline: 'Zip can’t be longer than 9 characters.',
                    gcalert: 'Zip cannot be longer than 9 characters.'
                }
            }
        ]
    },
    phone: {
        rules: [
            {
                type: 'CUSTOM',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: {
                    // Empty is allowed (field is optional); otherwise require a complete 10-digit
                    // phone. This matches the PhoneInput field's own validation so the inline error
                    evaluator: (value: unknown) => !value || validateLendersListPhone(value as string)
                },
                messages: {
                    inline: 'Enter a valid phone number.',
                    gcalert: 'Enter a valid lender phone number.'
                }
            }
        ]
    }
};
